import { AudioButton } from '../../components/AudioButton.tsx'
import { SourceLink } from '../../components/SourceLink.tsx'
import { useLatinOn } from '../../lib/prefs.ts'
import { arNum } from '../ayat/ayat.ts'
import type { Passage } from './pegangan.ts'

/**
 * A verse range from the dataset: Arabic, optional Latin, translation, reference (linked to Kemenag) and one play button
 * for all of it. Used by Pegangan, Mutiara and Teman Cerita.
 */
export function PassageBlock({ p, id, what }: { p: Passage; id: string; what: string }) {
  const latin = useLatinOn()
  const audio = p.verses?.flatMap((v) => (v.audio ? [v.audio] : [])) ?? []
  if (!p.verses) {
    return <p className="muted"><SourceLink href={p.url}>{p.ref}</SourceLink>. Teks ayat tampil di sini setelah data Al-Qur’an terpasang.</p>
  }
  return (
    <>
      <p className="ar verse-ar" lang="ar" dir="rtl">
        {p.verses.map((v) => <span key={v.k}>{v.ar} <span className="end">۝{arNum(v.k)}</span> </span>)}
      </p>
      {latin && p.verses.some((v) => v.latin) && <p className="lat">{p.verses.map((v) => v.latin).join(' ')}</p>}
      {/* no quote marks of our own: Kemenag translations often contain their own */}
      <p className="pg-tr">{p.verses.map((v) => v.terjemah).join(' ')}</p>
      <div className="pg-ref-row">
        <SourceLink href={p.url} className="pg-ref">{p.ref}</SourceLink>
        {audio.length > 0 && <AudioButton id={id} srcs={audio} what={what} />}
      </div>
    </>
  )
}
